var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { css, html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { DefaultMinDecibels, DefaultMaxDecibels, DefaultFftSize, } from "./constants.js";
import { RrScopeLine } from "./scope-line.js";
import { Zoom, DefaultZoom } from "../coordinates/zoom.js";
import "./scope-background.js";
import "./scope-line.js";
let RrScope = class RrScope extends LitElement {
    constructor() {
        super(...arguments);
        this.centerFrequency = 0;
        this.frequencyScale = 1;
        this.minDecibels = DefaultMinDecibels;
        this.maxDecibels = DefaultMaxDecibels;
        this.fftSize = DefaultFftSize;
        this.zoom = DefaultZoom;
    }
    static get styles() {
        return [
            css `
        :host {
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          background: black;
          position: relative;

          --top-caption-margin: 16px;
          --left-caption-margin: 24px;
        }

        #container {
          position: relative;
          width: 100%;
          height: 100%;
        }

        #background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        #line {
          position: absolute;
          top: var(--top-caption-margin);
          left: var(--left-caption-margin);
          width: calc(100% - var(--left-caption-margin));
          height: calc(100% - var(--top-caption-margin));
        }
      `,
        ];
    }
    render() {
        return html `<div id="container">
      <rr-scope-background
        id="background"
        .centerFrequency=${this.centerFrequency}
        .bandwidth=${this.bandwidth}
        .frequencyScale=${this.frequencyScale}
        .minDecibels=${this.minDecibels}
        .maxDecibels=${this.maxDecibels}
        .fftSize=${this.fftSize}
        .zoom=${this.zoom}
      ></rr-scope-background>
      <rr-scope-line
        id="line"
        .minDecibels=${this.minDecibels}
        .maxDecibels=${this.maxDecibels}
        .fftSize=${this.fftSize}
        .zoom=${this.zoom}
      ></rr-scope-line>
    </div> `;
    }
    addFloatSpectrum(spectrum) {
        if (spectrum.length != this.fftSize) {
            this.fftSize = spectrum.length;
        }
        this.line?.addFloatSpectrum(spectrum);
    }
};
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrScope.prototype, "bandwidth", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "center-frequency" }),
    __metadata("design:type", Number)
], RrScope.prototype, "centerFrequency", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "frequency-scale" }),
    __metadata("design:type", Number)
], RrScope.prototype, "frequencyScale", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "min-decibels" }),
    __metadata("design:type", Number)
], RrScope.prototype, "minDecibels", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "max-decibels" }),
    __metadata("design:type", Number)
], RrScope.prototype, "maxDecibels", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrScope.prototype, "fftSize", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", typeof (_a = typeof Zoom !== "undefined" && Zoom) === "function" ? _a : Object)
], RrScope.prototype, "zoom", void 0);
__decorate([
    query("#line"),
    __metadata("design:type", typeof (_b = typeof RrScopeLine !== "undefined" && RrScopeLine) === "function" ? _b : Object)
], RrScope.prototype, "line", void 0);
RrScope = __decorate([
    customElement("rr-scope")
], RrScope);
export { RrScope };
